import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('@masivapp/masivapp-email-preview-front', 2);
